var _rect, _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _ellipse2, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCivilLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 136,
    viewBox: "0 0 144 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4858,
    width: 119.7,
    height: 50.0154,
    rx: 25.0077,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2953 61.8086L37.3183 44.528L57.2722 44.528L47.2953 61.8086Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7489 61.8086L86.7719 44.528L106.726 44.528L96.7489 61.8086Z",
    fill: "#212121"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.134,
    cy: 77.5976,
    rx: 13.207,
    ry: 13.207,
    fill: "#FFDCD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1443 97.8458L46.9596 88.1607L35.22 79.0625L32.2852 97.8458H43.1443Z",
    fill: "#FFDCD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7298 74.0795L60.1652 72.3185C57.8173 64.9813 48.1321 61.7529 40.5014 66.7422C34.3968 70.7337 34.436 77.797 35.2186 80.8297L43.7298 74.0795Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7694 100.267C12.0424 96.043 15.9326 93.1523 20.3441 93.1523H56.3925C63.0964 93.1523 67.9015 99.6191 65.9671 106.038L59.081 128.887C57.8081 133.111 53.9178 136.002 49.5064 136.002H13.458C6.75409 136.002 1.9489 129.535 3.8833 123.116L10.7694 100.267Z",
    fill: "#3A7EFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2186 108.418C42.1471 108.418 37.8269 112.368 36.3008 114.343L37.7095 119.571H44.0489C45.4576 119.571 47.5707 118.874 48.9795 117.828C50.1065 116.992 51.3274 114.459 51.797 113.297C56.7276 113.297 60.9539 112.949 60.9539 111.206C60.9539 109.464 53.5579 108.418 47.2186 108.418Z",
    fill: "#FFDCD5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.207,
    cy: 13.207,
    rx: 13.207,
    ry: 13.207,
    transform: "matrix(-1 0 0 1 109.043 64.3906)",
    fill: "#FFDCD5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.826 97.8458L97.0107 88.1607L108.75 79.0625L111.685 97.8458H100.826Z",
    fill: "#FFDCD5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.238 74.0795L83.8031 72.3185C86.151 64.9813 95.8361 61.7529 103.467 66.7422C109.571 70.7337 109.532 77.797 108.75 80.8297L100.238 74.0795Z",
    fill: "#212121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.199 100.267C131.926 96.043 128.036 93.1523 123.624 93.1523H87.5759C80.872 93.1523 76.0668 99.6191 78.0013 106.038L84.8874 128.887C86.1603 133.111 90.0506 136.002 94.462 136.002H130.51C137.214 136.002 142.019 129.535 140.085 123.116L133.199 100.267Z",
    fill: "#212121"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8027 108.418C102.874 108.418 107.194 112.368 108.72 114.343L107.312 119.571H100.972C99.5636 119.571 97.4505 118.874 96.0417 117.828C94.9147 116.992 93.6938 114.459 93.2242 113.297C88.2936 113.297 84.0674 112.949 84.0674 111.206C84.0674 109.464 91.4633 108.418 97.8027 108.418Z",
    fill: "#FFDCD5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7611 14.6077L63.4011 29.4877H59.6211L59.2611 14.6077H63.7611ZM59.0811 33.6277C59.0211 32.3077 60.1611 31.1977 61.5411 31.2277C62.8311 31.1977 63.9711 32.3077 64.0011 33.6277C63.9711 35.0077 62.8311 36.1177 61.5411 36.0877C60.1611 36.1177 59.0211 35.0077 59.0811 33.6277ZM72.9311 14.6077L72.5711 29.4877H68.7911L68.4311 14.6077H72.9311ZM68.2511 33.6277C68.1911 32.3077 69.3311 31.1977 70.7111 31.2277C72.0011 31.1977 73.1411 32.3077 73.1711 33.6277C73.1411 35.0077 72.0011 36.1177 70.7111 36.0877C69.3311 36.1177 68.1911 35.0077 68.2511 33.6277ZM82.101 14.6077L81.741 29.4877H77.961L77.601 14.6077H82.101ZM77.421 33.6277C77.361 32.3077 78.501 31.1977 79.881 31.2277C81.171 31.1977 82.311 32.3077 82.341 33.6277C82.311 35.0077 81.171 36.1177 79.881 36.0877C78.501 36.1177 77.361 35.0077 77.421 33.6277Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCivilLarge);
export default __webpack_public_path__ + "static/media/IcCivilLarge.08dfa28060a879eeaea51c5c3087f3ec.svg";
export { ForwardRef as ReactComponent };